<template>
	<main>
		<div class="output-box" :style="{ 'background-image': `url(${ require( '@/assets/sprites/gui/sMissionFolder-blank.png' ) })` }">
			<textarea :value="JSON.stringify(compiledJson, null, 2)" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"></textarea>
		</div>

		<div class="content font-sans">
		<p>To use: Save this as <span class="color-y">custom.json</span>, and put it inside your <span class="color-b">Levels</span> folder.</p>
		<p>To publish, upload it in a ZIP file with your level(s).</p>
		</div>
	</main>
</template>

<script>
	import npc from '@/modules/data/npc';

	export default {
		name: 'Output',
		data() {
			return {
				dcpVersion: '1.5.0',
			}
		},
		computed: {
			compiledJson()
			{
				return {
					DCP: {
						dcpc_DCP__version: this.dcpVersion
					},
					player_properties: {
						dcpc_player__sprite_base: 's' + this.getCurrentCharacterId,
						dcpc_player__sprite_removeweaponstring: ( this.getCurrentCharacterId !== 'P' ),
						dcpc_player__run_speed:   npc[this.getCurrentCharacterId].run_speed,
						dcpc_player__health:      npc[this.getCurrentCharacterId].hp,
						dcpc_player__blood_type:  npc[this.getCurrentCharacterId].blood_type,
						dcpc_player__no_ragdoll: !npc[this.getCurrentCharacterId].canRagdoll
					},
					player_weapons: {
						dcpc_player_weapons__set_primary: this.getPrimary,
						dcpc_player_weapons__set_secondary: this.getSecondary,
						dcpc_player_weapons__ignore_carryover: true
					},
					player_canuse: {
						dcpc_player_canuse__gun_weapons:    npc[this.getCurrentCharacterId].abilities.gun_weapons,
						dcpc_player_canuse__melee_smash:    npc[this.getCurrentCharacterId].abilities.melee_smash,
						dcpc_player_canuse__melee_throw:    npc[this.getCurrentCharacterId].abilities.melee_throw,
						dcpc_player_canuse__vent:           npc[this.getCurrentCharacterId].abilities.vent,
						dcpc_player_canuse__cover:          npc[this.getCurrentCharacterId].abilities.cover,
						dcpc_player_canuse__ladder:         npc[this.getCurrentCharacterId].abilities.ladder,
						dcpc_player_canuse__weapon_pickups: npc[this.getCurrentCharacterId].abilities.weapon_pickups,
						dcpc_player_canuse__cartrunk:       npc[this.getCurrentCharacterId].abilities.cartrunk,
						dcpc_player_canuse__charon:         npc[this.getCurrentCharacterId].abilities.charon,
					},
				}
			},
			getCurrentCharacterId()
			{
				return this.$store.getters.getCharacterId;
			},
			getPrimary()
			{
				return this.$store.getters.getPrimaryWeapon;
				// return npc[this.getCurrentCharacterId].wpn1_index; //@TODO
			},
			getSecondary()
			{
				return this.$store.getters.getSecondaryWeapon;
			},
		},
	}

</script>

<style lang="scss" scoped>
	main {
		padding-top: 20px;
	}

	.output-box {
		background-image: no-repeat;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		height: 550px;
		margin: 0 auto 40px;
		padding-left: 40px;
		padding-top: 20px;
		width: 500px;
		position: relative;
		left: 20px;
	}

	textarea {
		background-color: rgba(255, 255, 255, 0.2);
		color: #29231a;
		display: block;
		height: 100%;
		max-height: 480px;
		width: 400px;
		border: 3px dashed #635846;
	}

	p {
		font-size: 1.1rem;
		margin-bottom: 10px;
		text-align: center;
	}
</style>